import React from 'react'
import { NavLink } from 'react-router-dom';

import About from './About'
const Nav_items = () => {
    return (
        <span className="nav-items">
                    
                <NavLink className='nav-link' to="/">Home</NavLink>
                <NavLink className='nav-link' to="/category">Category</NavLink>
                <NavLink className='nav-link' to="/about">About</NavLink>
                <a className='nav-link' href="mailto:mohitkushwaha4508@gmail.com">Email Us</a> 
                {/* <NavLink className='nav-link' to="/login">Login</NavLink> */}
                
                
                
               
                </span>
    )
}

export default Nav_items
